import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Select, {createFilter} from "react-select";
import { useTable } from "react-table";
import { getTerminalManagementActivityInfoApi } from "../Api";
import { DateFormatter } from "../Utils/DateFormatter";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";

function MgmtActivity(props) {
  const [terminalSelectData, setTerminalSelectData] = useState([]);
  const [selectedTerminal, setSelectedTerminal] = useState();
  const [data, setData] = useState([]);
  const [managementInfo, setManageMentInfo] = useState();
  const history = useHistory();
  const location = useLocation();
  const columns = [
    {
      Header: "Management Date",
      accessor: "managementActivity",
    },
    {
      Header: "Management Activity",
      accessor: "dtManagement",
      Cell:props=>{return DateFormatter(props.value)}
    }
  ];

  function Table({ columns, data }) {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
      useTable({
        columns,
        data,
      });

    return (
      <>
        <div className="report_table_outer">
          <div className="table-responsive">
            <table {...getTableProps()} className="table table-bordered  small">
              <thead className="thead-light">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                      // onClick={() => console.log(row.original)}
                    >
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }

  const handleTerminalSelectClick = (e) => {
    history.push({
      pathname: "/termManagement/terMinalDetails",
      search: `terminalID=${selectedTerminal.value}`,
    });
  };

  useEffect(() => {
    props?.terminalsData?.map((item, index) => {
      setTerminalSelectData((options) => [
        ...options,
        { label: item.terminalID, value: item.terminalID },
      ]);
    });
    const terminalId = location?.search?.split("=")?.[1];
    setSelectedTerminal({ label: terminalId, value: terminalId });
    const getCassetteData = async () => {
      const result = await axios.get(`${getTerminalManagementActivityInfoApi}?pTerminalID=${terminalId}&pStartDate=2021-04-27 12:08:50`);
      setManageMentInfo(result?.data?.response[0]);
      setData(result.data?.response);
    };
    getCassetteData();
    return () => {
      setData([]);
      setTerminalSelectData([]);
    };
  }, [location]);

  return (
    <div>
      <div className="mt-3">
        <form>
          <div class="form-group form-inline">
            <label for="exampleInputEmail1">Terminal ID:</label>
            <div class="input-group ml-2">
              <Select
                options={terminalSelectData}
                filterOption={createFilter({ ignoreAccents: false })}
                captureMenuScroll={false}
                classNamePrefix="custom-select"
                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                value={selectedTerminal}
                onChange={(e) => setSelectedTerminal(e)}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    flex: 1,
                    width: "13vw",
                  }),
                }}
              />
              <span
                class="input-group-text"
                role="button"
                onClick={handleTerminalSelectClick}
              >
                Go
              </span>
            </div>
          </div>
        </form>
        <div className="mt-3">
          <Table columns={columns} data={data} />
        </div>
      </div>
    </div>
  );
}

export default MgmtActivity;
